import { TextField } from "@mui/material"
import { styled } from "@mui/system"

export const TextFieldInputStyled = styled(TextField)(({ theme }) => ({
    "& .MuiFilledInput-root": {
        backgroundColor: theme.palette.input.background.white05,
        color: theme.palette.primary.contrastText,
        borderRadius: 0,
        border: `1px solid ${theme.palette.input.borderColor.primary}`,
        height: '48px',

        "&:hover": {
            backgroundColor: theme.palette.input.background.secondary,
        },

        "&.Mui-focused:not(.Mui-error)": {
            backgroundColor: theme.palette.input.background.secondary,
        },

        "&.Mui-error": {
            backgroundColor: theme.palette.input.background.primary,
            border: `1px solid ${theme.palette.input.borderColor.warning}`,
        },

        "& svg": {
            color: theme.palette.icon.main,
        },

        "&.Mui-error svg": {
            color: theme.palette.icon.error,
        },

        "&:before, &:after": {
            display: "none",
        },

        "&:hover:not(.Mui-disabled):before": {
            border: `2px solid ${theme.palette.primary.main2}`,
        },

        "&.Mui-focused:after": {
            border: `2px solid ${theme.palette.primary.main2}`,
        },

        "&.Mui-error:after": {
            border: `2px solid ${theme.palette.input.borderColor}`,
        },

        "& input:-webkit-autofill": {
            backgroundColor: "rgba(210, 159, 9, 0.3) !important",
            transition: "background-color 5000s ease-in-out 0s",
            WebkitTextFillColor: `${theme.palette.primary.contrastText} !important`,
            caretColor: `${theme.palette.primary.contrastText} !important`,
        },
    },

    "& .MuiInputBase-input": {
        fontSize: theme.typography.fontSizes.sm,
        paddingLeft: "12px",
        lineHeight: 1.4,
    },

    "& .MuiInputLabel-root.Mui-focused": {
        color: theme.palette.common.white,
        opacity: 0.7,
    },

    "& .MuiInputLabel-root": {
        color: theme.palette.common.white,
        opacity: 0.7,
        marginTop: -2,
        fontSize: "14px",
    },

    "& .MuiInputLabel-root.has-start-icon": {
        marginLeft: "44px",
    },

    "& .MuiInputLabel-root.Mui-error": {
        color: theme.palette.common.white,
        opacity: 0.7,
    },

    "& .MuiInputAdornment-root": {
        marginTop: "0 !important",
        alignItems: "center",
        display: "flex",
        height: "100%",
        "& svg": {
            display: "block",
            verticalAlign: "middle",
        },
    },

    "& .MuiInputAdornment-positionStart": {
        marginLeft: 0,
        height: "100%",
        alignItems: "center",
      
    },

    "& .MuiFormHelperText-root": {
        marginTop: 8,
        marginLeft: 0,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeights.regular,
        fontStyle: "normal",
        fontSize: theme.typography.fontSizes.sm,
        lineHeight: "100%",
        letterSpacing: "0%",
        color: theme.palette.text.warning,
    },
}))
